import { Box, Divider, FormControlLabel, FormGroup, Grid, Stack, Switch } from "@mui/material";
import { ReactComponent as DeleteIcon } from "assets/DeleteIcon.svg";
import { ReactComponent as EditIcon } from "assets/EditIcon.svg";
import { ReactComponent as ReorederSections } from "assets/ReorderSections.svg";
import { ReactComponent as CopyLink } from "assets/copy_link.svg";
import FileAdd from "assets/fileAdd";
import { clearSelectedCards } from "components/app/App.slice";
import ThemeContext from "components/app/Context";
import BookmarkPlan from "components/common/Bookmark";
import Button from "components/common/Button";
import DialogFormation from "components/common/DialogFormation";
import DraggableList from "components/common/DraggableList";
import Feedback from "components/common/Feedback";
import FunctionalAreas from "components/common/FunctionalAreas";
import HTMLRenderer from "components/common/HTMLRenderer";
import InfoBar from "components/common/InfoBar";
import KebabMenu from "components/common/KebabMenu";
import ButtonLink from "components/common/Link";
import MarkCompleteButton from "components/common/MarkCompleteButton";
import ScrollAwareHeader from "components/common/ScrollAwareHeader";
import { setFeedbackDetails } from "components/common/Snackbar/snackbar.slice";
import Timing from "components/common/Timing";
import Typography from "components/common/Typography";
import UserAvatarList from "components/common/UserAvatarList";
import Calender from "components/common/calender/Calender";
import AssignPlanDialog from "components/common/plans/AssignPlanDialog";
import { addToMyPlansAsync } from "components/features/MyPlanDetails/MyPlanDetails.slice";
import { useTranslate } from "hooks/useTranslate";
import { useContext, useEffect, useState } from "react";
import { DropResult } from "react-beautiful-dnd";
import { useNavigate } from "react-router";
import { tokens } from "styles/Tokens";
import {
  ABOVE_PROPERTY,
  FEEDBACK_TIMER,
  accessTypes,
  brandDeadLine,
  brandDeadlinesType,
  initiative,
  messageTypes,
  messages,
  sourceValues
} from "utils/CommonConstants";
import {
  getChipDetails,
  getOwnersList,
  getPlanDetail,
  getPlanDuration,
  getPlantypeName,
  getUserHltId,
  matchOwnerWithHltId,
  reorder
} from "utils/CommonFunctions";
import { getUIFormatDate } from "utils/DateHelper";
import { pageNames, planTypes } from "utils/Types";
import { REDIRECT_URI } from "utils/URLConstants";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import AssignPlan from "../AboveProperty/PlanView/AssignPlan";
import { patchReorderSectionsAsync } from "../MyPlanDetails/MyPlanDetails.slice";
import Delete from "../MyPlans/Delete";
import Edit from "../MyPlans/Edit";
import { setIsPlanHighlight } from "../MyPlans/myplans.slice";
import MetricDetails from "../dashboard/MetricDetails";
import InviteMemberDialog from "./InviteMemberDialog";
import "./PlanDetailsContent.scss";

export default function PlanDetailsContent(props: any) {
  const translate = useTranslate();
  const navigate = useNavigate();
  const dispatch: any = useAppDispatch();
  const { selectedPlanDetail, plansType, isPlanBookmark, redirectFromDashboard, individualPropertyInncode } = props;
  const { selectedTab, searchActive, isSmeUser, isAdmin, innCode, activeActionCard } = useAppSelector(
    (state: any) => state.app
  );
  const [openDialog, setOpenDialog] = useState(Boolean);
  const selectedMyPlanDetail: any = useAppSelector((state) => state.myPlanDetails.myPlanDetails);
  const metricsPlansList: any = useAppSelector((state) => state.suggestedPlans.plansMetrics);
  const suggestedPlan = selectedTab === pageNames.suggested && getPlanDetail(selectedPlanDetail.id, metricsPlansList);
  const metrics = suggestedPlan?.metrics;
  const isActionHighlight = useAppSelector((state: any) => state.myplans?.MyPlans.isActionHighlight);
  const [items, setItems] = useState([]);

  const [reorderedData, setReorderedData] = useState({});
  const [isSaveEnabled, setIsSaveEnabled] = useState(false);
  const [openEditPlan, setOpenEditPlan] = useState(false);
  const [openAddToMyPlanConfirmDialog, setOpenAddToMyPlanConfirmDialog] = useState(false);
  const [openAddDueDate, setOpenAddDueDate] = useState(false);
  const [dueDate, setDueDate] = useState<any>();
  const [isCopyLinkSuccess, setIsCopyLinkSuccess] = useState(false);
  const [openDeleteCapthaDialog, setOpenDeleteCapthaDialog] = useState(Boolean);
  const [openInviteMemberDialog, setOpenInviteMemberDialog] = useState(Boolean);
  const assigneeList: any = useAppSelector((state) => state.myPlanDetails.ad);
  const [openAssignPlan, setOpenAssignPlan] = useState(false);
  const [multiplansAssign, setMultiplansAssign] = useState(false);
  const members = assigneeList?.filter(
    (users: any) =>
      selectedMyPlanDetail?.owners?.indexOf(users?.hltId) === -1 ||
      selectedMyPlanDetail?.members?.indexOf(users?.hltId) > -1
  );

  const { isMobileScreen }: any = useContext(ThemeContext);
  const addedToMyPlansDate = getUIFormatDate(selectedPlanDetail?.myPlans?.[0].createdDate);
  const isTemplatePlan = selectedMyPlanDetail.innCode === ABOVE_PROPERTY;
  const cardList: any = useAppSelector((state) => state.app.selectedCards?.cardList);

  useEffect(() => {
    setReorderedData({
      id: selectedPlanDetail?.id,
      reorderedSections: {
        sectionIds: []
      }
    });
    setItems(selectedPlanDetail?.sections);
  }, [selectedPlanDetail]);

  const SectionMenu = [
    {
      label: "Edit Plan",
      icon: EditIcon,
      accessType: accessTypes.update,
      action: () => {
        setOpenEditPlan(true);
      },
      enabled: true
    },
    {
      label: "Reorder Sections",
      icon: ReorederSections,
      accessType: accessTypes.update,
      enabled: items?.length > 1,
      action: () => {
        setOpenDialog(true);
      }
    },
    {
      label: "Delete Plan",
      icon: DeleteIcon,
      accessType: accessTypes.delete,
      enabled: true,
      action: () => {
        if (!isAdmin && !matchOwnerWithHltId(selectedMyPlanDetail?.owners)) {
          dispatch(
            setFeedbackDetails({
              shouldShow: true,
              type: "plan",
              displayName: getOwnersList(),
              setState: setFeedbackDetails({ shouldShow: false }),
              messageType:
                selectedMyPlanDetail?.owners.length > 1 ? messageTypes.multipleOwners : messageTypes.singleOwner
            })
          );
          return;
        }
        setOpenDeleteCapthaDialog(true);
      }
    }
  ];

  const PlanMenu = isSmeUser
    ? [
        {
          label: "Assign Plan",
          enabled: true,
          action: () => {
            setOpenAssignPlan(true);
          }
        },
        {
          label: "Copy shareable link",
          icon: CopyLink,
          action: () => {
            const link = REDIRECT_URI + "/plandetails/" + selectedPlanDetail?.id + "?isshareable=true";
            navigator.clipboard.writeText(link).then(function () {
              setIsCopyLinkSuccess(true);
            });
            setIsCopyLinkSuccess(false);
          },
          enabled: true
        }
      ]
    : [
        {
          label: "Copy shareable link",
          icon: CopyLink,
          action: () => {
            const link = REDIRECT_URI + "/plandetails/" + selectedPlanDetail?.id + "?isshareable=true";
            navigator.clipboard.writeText(link).then(function () {
              setIsCopyLinkSuccess(true);
            });
            setIsCopyLinkSuccess(false);
          },
          enabled: true
        }
      ];

  const handleCloseDialog = () => {
    setItems(selectedPlanDetail?.sections);
    setIsSaveEnabled(false);
    setOpenDialog(false);
  };

  const saveReorder = () => {
    dispatch(patchReorderSectionsAsync(reorderedData));
    setOpenDialog(false);
    setIsSaveEnabled(false);
  };

  const createSectionArray = (itemDetails: any) => {
    const reorderedList = itemDetails.map((item: { id: any }) => item.id);
    setReorderedData({
      ...reorderedData,
      reorderedSections: {
        sectionIds: [...reorderedList]
      }
    });
  };

  const onDragEnd = ({ destination, source }: DropResult) => {
    // dropped outside the list
    if (!destination) return;
    const newItems: any = reorder(items, source.index, destination.index);
    setItems(newItems);
    setIsSaveEnabled(true);
    createSectionArray(newItems);
  };

  const getOwners = () => {
    if (plansType === planTypes.MyPlans)
      return (
        <Grid item xs={12} paddingTop="12px">
          <Typography variant="label" color={tokens.Text.General.Tertiary}>
            {`Owner: `}
          </Typography>
          <Typography variant="label" showBold color={tokens.Text.General.Tertiary}>
            {getOwnersList()}
          </Typography>
        </Grid>
      );
  };

  const getInfoBarList: any = () => {
    return (
      <Grid
        item
        xs={12}
        sm={7}
        gap="8px"
        marginTop={isMobileScreen ? "16px" : 2}
        display="flex"
        flexWrap="wrap"
        minHeight={isMobileScreen ? "70px" : ""}
        sx={{ color: isMobileScreen ? tokens.Text.General.PrimaryBody : "" }}
      >
        <Grid width={isMobileScreen ? "48%" : "unset"}>
          <InfoBar
            sx={{
              height: isMobileScreen ? "100%" : ""
            }}
            label={`Priority  `}
            value={selectedPlanDetail?.priority === null ? "Undefined" : selectedPlanDetail?.priority}
          ></InfoBar>
        </Grid>
        <Grid width={isMobileScreen ? "48%" : "unset"}>
          <InfoBar
            sx={{
              height: isMobileScreen ? "100%" : ""
            }}
            label={`Due Date  `}
            value={selectedPlanDetail?.dueDate ? getUIFormatDate(selectedPlanDetail?.dueDate) : ""}
          ></InfoBar>
        </Grid>
        <Grid width={isMobileScreen ? "100%" : "unset"}>
          <InfoBar
            sx={{
              height: isMobileScreen ? "100%" : ""
            }}
            label="Progress"
            progressChip={{
              ...getChipDetails(
                selectedPlanDetail?.totalCards,
                selectedPlanDetail?.cardsCompleted,
                selectedPlanDetail?.sections ? selectedPlanDetail?.sections.map((a: any) => a.cards).flat() : []
              ),
              iconAtStart: true
            }}
          ></InfoBar>
        </Grid>
      </Grid>
    );
  };

  const getSourceValue = () => {
    const planType = getPlantypeName(selectedPlanDetail?.planType);
    if (selectedTab === pageNames.suggested) {
      return suggestedPlan?.breadCrumbPlanType;
    } else if (planType === initiative) return sourceValues.initiative;
    else if (planType === brandDeadLine) return sourceValues.deadline;
    else if (searchActive) return sourceValues.librarySearch;
    else return sourceValues.library;
  };

  const addToMyPlansHandler = async () => {
    const response = await dispatch(
      addToMyPlansAsync({
        libraryPlan: selectedPlanDetail,
        innCode,
        source: getSourceValue(),
        planType: getPlantypeName(selectedPlanDetail?.planType),
        dueDate: dueDate
      })
    );

    if (response?.payload?.id) navigate(`/myplandetails/${response?.payload?.id}`);
    else setOpenAddDueDate(false);
  };

  const handleClose = () => {
    setMultiplansAssign(false);
  };

  useEffect(() => {
    return () => {
      dispatch(setIsPlanHighlight(false));
    };
  }, []);

  useEffect(() => {
    dispatch(setIsPlanHighlight(selectedPlanDetail?.isActionHighlight));
  }, [selectedPlanDetail]);

  const getMarkCompleteButton = () => {
    return <MarkCompleteButton source={{ source: "plan" }} />;
  };
  const handleHighlight = () => {
    const hltId: string = getUserHltId();
    const filterCards = cardList.filter((task: any) => !task.assignee || !task.assignee?.includes(hltId));
    if (!isActionHighlight) {
      filterCards.forEach((element: any) => {
        dispatch(clearSelectedCards(element));
      });
    }

    dispatch(setIsPlanHighlight(!isActionHighlight));
  };

  const HighlightAction = () => {
    return (
      <FormGroup>
        <FormControlLabel
          className="highlight-action"
          sx={{ mr: "8px", ml: 0 }}
          control={<Switch size="small" onChange={() => handleHighlight()} checked={isActionHighlight} />}
          label={
            <Typography variant="body2" color={tokens.Border.General.Secondary} sx={{ marginRight: "8px" }}>
              {translate("myplan.highlight.myActions")}
            </Typography>
          }
          labelPlacement="start"
        />
      </FormGroup>
    );
  };

  const getAddPlanButton = (isSmallHeader = false) => {
    return (
      !isAdmin &&
      !redirectFromDashboard && (
        <Button
          accessType={accessTypes.update}
          sx={{ marginLeft: isSmallHeader ? 0 : "auto", flex: isSmallHeader && isMobileScreen ? 1 : "unset" }}
          variant="primary"
          label={translate("library.addToMyPlan")}
          startIcon={<FileAdd />}
          onClick={() => (addedToMyPlansDate ? setOpenAddToMyPlanConfirmDialog(true) : setOpenAddDueDate(true))}
        />
      )
    );
  };

  const getAssignPlanButton = (isSmallHeader = false) => {
    return (
      <Button
        sx={{ marginLeft: isMobileScreen ? "auto" : "unset", flex: isSmallHeader && isMobileScreen ? 1 : 0 }}
        onClick={() => {
          if (selectedMyPlanDetail?.totalCards === 0)
            dispatch(
              setFeedbackDetails({
                shouldShow: true,
                setState: setFeedbackDetails({ shouldShow: false }),
                message: "The plan cannot be assigned as there are no action cards for the plan"
              })
            );
          else setMultiplansAssign(true);
        }}
        variant="primary"
        label="Assign plan"
        accessType={accessTypes.assign}
      />
    );
  };

  return (
    <>
      <Grid id="infoBarRoot" container sx={{ backgroundColor: tokens.Background.General.Primary }}>
        {!activeActionCard?.planId && (
          <ScrollAwareHeader elementId="infoBarRoot">
            <Typography variant="h5" showBold color={tokens.Text.General.PrimaryHeadline} sx={{ flex: 1 }}>
              {selectedPlanDetail?.name || selectedMyPlanDetail?.name}
            </Typography>
            <Stack
              spacing={isMobileScreen ? 2 : 0}
              flex="1"
              flexDirection="row"
              alignItems="center"
              justifyContent={isMobileScreen ? "space-between" : "flex-end"}
              flexWrap="wrap"
              sx={{ width: isMobileScreen ? "100%" : "auto", mt: isMobileScreen ? "16px" : "0 !important" }}
            >
              {plansType === planTypes.MyPlans && !isTemplatePlan && (
                <>
                  {selectedMyPlanDetail?.innCode !== ABOVE_PROPERTY && <HighlightAction />}
                  <Button
                    sx={{
                      mr: "8px",
                      width: isMobileScreen ? "94px" : "auto",
                      minWidth: isMobileScreen ? "94px" : "116px",
                      mt: "0 !important"
                    }}
                    onClick={() => {
                      setOpenInviteMemberDialog(true);
                    }}
                    variant="secondary"
                    label="Share Plan"
                  />
                  {getMarkCompleteButton()}
                </>
              )}
              {plansType === planTypes.AllPlans && getAddPlanButton(true)}
              {individualPropertyInncode && (
                <Button
                  sx={{ marginLeft: "auto" }}
                  label="Assign plan"
                  accessType={accessTypes.assign}
                  onClick={() => {
                    setMultiplansAssign(true);
                  }}
                />
              )}
              {isTemplatePlan && getAssignPlanButton(true)}
              {plansType !== planTypes.MulipleAssign && !isMobileScreen ? (
                <KebabMenu options={plansType === planTypes.MyPlans ? SectionMenu : PlanMenu} />
              ) : null}
            </Stack>
          </ScrollAwareHeader>
        )}
        {selectedPlanDetail && (
          <>
            <Feedback form="addToMyPlans" message={messages.planAdded} />
            <Feedback
              form=""
              actionStatus={{ shouldShow: isCopyLinkSuccess, variant: "success", timer: FEEDBACK_TIMER }}
              message="Link Copied."
            />

            <Feedback form="addInvitee" message={messages.memberInvited} />

            {plansType === planTypes.MyPlans && (
              <Feedback form="copyAction" message={translate("myPlan.importFromLibrary.feedback")} />
            )}

            <Grid item xs={12} display="flex" sx={{ flexDirection: { xs: "column", sm: "row" } }}>
              <Grid item xs={12} sm={6}>
                <Typography variant="h4" showBold color={tokens.Text.General.PrimaryHeadline}>
                  {selectedPlanDetail?.name}
                </Typography>
              </Grid>
              {isMobileScreen && getOwners()}
              <Grid
                item
                xs={12}
                sm={6}
                display="flex"
                gap={"8px"}
                alignSelf="right"
                justifyContent={{ xs: "space-between", sm: "flex-end" }}
                alignItems={"center"}
                marginTop={{ xs: "16px", sm: 0 }}
                className="myplan-action-wrapper"
              >
                {plansType === planTypes.MyPlans && selectedMyPlanDetail?.innCode !== ABOVE_PROPERTY && (
                  <Grid
                    item
                    display={"flex"}
                    flexDirection={"row"}
                    gap={"8px"}
                    alignItems={"center"}
                    sx={{ flexGrow: isMobileScreen && 1 }}
                    className="toggle-time-wrapper"
                  >
                    <HighlightAction />
                  </Grid>
                )}
                {plansType === planTypes.AllPlans && (
                  <>
                    {!redirectFromDashboard && (
                      <>
                        {" "}
                        <BookmarkPlan isBookmarked={isPlanBookmark} cmsId={selectedPlanDetail.id} />
                        <Divider
                          sx={{
                            height: "12px",
                            width: "1px",
                            backgroundColor: tokens.Border.General.Secondary
                          }}
                          orientation="vertical"
                        ></Divider>
                      </>
                    )}
                  </>
                )}
                <Timing duration={getPlanDuration(selectedPlanDetail?.sections)} />
                {plansType !== planTypes.MulipleAssign && (
                  <KebabMenu options={plansType === planTypes.MyPlans ? SectionMenu : PlanMenu} />
                )}
              </Grid>
            </Grid>
            {!isMobileScreen && getOwners()}
          </>
        )}

        <Grid item xs={12} sm={6} marginTop={isMobileScreen ? "16px" : "10px"} sx={{ overflowWrap: "break-word" }}>
          <Typography component="div" variant={"body2"} color={tokens.Text.General.PrimaryBody}>
            <HTMLRenderer content={selectedPlanDetail?.summary} />
          </Typography>
        </Grid>
        {plansType === planTypes.MyPlans && !isTemplatePlan && getInfoBarList()}
        {(plansType === planTypes.AllPlans || plansType === planTypes.MulipleAssign) && (
          <Grid item xs={12} sm={8} marginTop={2}>
            <FunctionalAreas direction="row" functionalAreaIds={selectedPlanDetail?.functionalAreaIds} />
          </Grid>
        )}

        {plansType === planTypes.AllPlans && (
          <Grid
            item
            xs={12}
            marginTop={"28px"}
            display="flex"
            alignItems={"flex-start"}
            gap={"4px"}
            flexDirection={isMobileScreen ? "column" : "row"}
          >
            {selectedPlanDetail?.myPlans && !redirectFromDashboard && (
              <>
                <Typography children={"Last Added:"}></Typography>
                <ButtonLink
                  text={addedToMyPlansDate}
                  textVariant={"body2"}
                  onClick={() => navigate(`/myplandetails/${selectedPlanDetail?.myPlans[0].id}`)}
                ></ButtonLink>
              </>
            )}
            {selectedTab === pageNames.suggested && (
              <Box display="flex" flexDirection={"row"} flexWrap={"wrap"} maxWidth={isMobileScreen ? "100%" : "80%"}>
                {metrics &&
                  Object.keys(metrics).map((metric: any, index: any) => {
                    return (
                      <>
                        <MetricDetails
                          key={metric}
                          metric={metrics[metric]}
                          metricsBar={true}
                          sx={{ marginX: "16px", width: isMobileScreen ? "100%" : "320px" }}
                        />
                        {Object.keys(metrics).length > index + 1 && !isMobileScreen && (
                          <Divider
                            sx={{
                              height: "73px",
                              width: "1px",
                              backgroundColor: tokens.Border.General.Tertiary
                            }}
                            orientation="vertical"
                          ></Divider>
                        )}
                      </>
                    );
                  })}
              </Box>
            )}

            {getAddPlanButton()}
            {individualPropertyInncode && (
              <Button
                sx={{ marginLeft: "auto" }}
                label="Assign plan"
                accessType={accessTypes.assign}
                onClick={() => {
                  setMultiplansAssign(true);
                }}
              />
            )}
          </Grid>
        )}
        {plansType === planTypes.MyPlans && (
          <>
            {isTemplatePlan ? (
              <Grid
                item
                xs={12}
                gap="20px"
                marginTop={2}
                display="flex"
                alignItems={"center"}
                justifyContent={{ md: "flex-end", xs: "space-between" }}
              >
                {getAssignPlanButton()}
              </Grid>
            ) : (
              <Grid
                item
                xs={12}
                md={5}
                gap="20px"
                marginTop={2}
                display="flex"
                alignItems={"center"}
                justifyContent={{ md: "flex-end", xs: "space-between" }}
              >
                {members?.length > 0 && <UserAvatarList users={members} max={3} />}
                <Button
                  sx={{ marginLeft: isMobileScreen ? "auto" : "unset" }}
                  onClick={() => {
                    setOpenInviteMemberDialog(true);
                  }}
                  variant="secondary"
                  label="Share Plan"
                />
                {!isMobileScreen && !isTemplatePlan && getMarkCompleteButton()}
              </Grid>
            )}
            {isMobileScreen && !isTemplatePlan && (
              <Box marginTop={"12px"} width={"100%"}>
                {getMarkCompleteButton()}
              </Box>
            )}
          </>
        )}
      </Grid>

      <Feedback form="reorderSections" message="Sort Order changes have been saved." />

      {openEditPlan && (
        <Edit
          isTemplateType={selectedPlanDetail?.innCode === ABOVE_PROPERTY}
          openEditPlan={openEditPlan}
          setOpenEditPlan={setOpenEditPlan}
        />
      )}

      {openAddToMyPlanConfirmDialog && (
        <DialogFormation
          title="Add plan"
          openDialog={true}
          handleClose={() => setOpenAddToMyPlanConfirmDialog(false)}
          actionConfig={
            <div className="modal-config-wrapper">
              <Button variant="secondary" label="Cancel" onClick={() => setOpenAddToMyPlanConfirmDialog(false)} />
              <Button
                variant="primary"
                label="Proceed"
                onClick={() => {
                  setOpenAddDueDate(true);
                  setOpenAddToMyPlanConfirmDialog(false);
                }}
              />
            </div>
          }
        >
          The plan has already been added to My Plans on {addedToMyPlansDate}. Do you want to add another copy of this
          plan?
        </DialogFormation>
      )}

      {openDialog && (
        <DialogFormation
          title="Reorder Sections"
          openDialog={openDialog}
          handleClose={handleCloseDialog}
          actionConfig={
            <div className="modal-config-wrapper">
              <Button variant="secondary" label="Cancel" onClick={handleCloseDialog} width="25%" />
              <Button disabled={!isSaveEnabled} variant="primary" label="Save" onClick={saveReorder} width="25%" />
            </div>
          }
        >
          <DraggableList items={items} onDragEnd={onDragEnd} />
        </DialogFormation>
      )}

      {openDeleteCapthaDialog && (
        <Delete
          openDeleteCapthaDialog={openDeleteCapthaDialog}
          setOpenDeleteCapthaDialog={setOpenDeleteCapthaDialog}
          plan={selectedPlanDetail}
        />
      )}
      <InviteMemberDialog
        openInviteMemberDialog={openInviteMemberDialog}
        setOpenInviteMemberDialog={setOpenInviteMemberDialog}
      />
      {openAssignPlan && (
        <AssignPlanDialog
          setOpenAssignPlanDialog={setOpenAssignPlan}
          selectedPlan={selectedPlanDetail}
          isPlanDetailView
        />
      )}
      {multiplansAssign && (
        <AssignPlan
          setOpenAssignPlanDialog={setMultiplansAssign}
          handleCloseDialog={handleClose}
          selectedPlanDetail={selectedPlanDetail}
          isTemplatePlan={isTemplatePlan}
          individualPropertyInncode={individualPropertyInncode}
        />
      )}
      {openAddDueDate && (
        <DialogFormation
          title="Select a due date"
          openDialog={openAddDueDate}
          handleClose={() => setOpenAddDueDate(false)}
          actionConfig={
            <div className="modal-config-wrapper">
              <Button variant="secondary" label="Cancel" onClick={() => setOpenAddDueDate(false)} width="25%" />
              <Button
                variant="primary"
                label={translate("library.addToMyPlan")}
                onClick={addToMyPlansHandler}
                width="25%"
              />
            </div>
          }
        >
          <div className="horizontal-center">
            <Box width="320px">
              {selectedPlanDetail?.planType === brandDeadlinesType && (
                <Typography
                  variant="body2"
                  color={tokens.Text.General.PrimaryBody}
                  sx={{ width: "284px", marginBottom: "24px", marginLeft: "24px" }}
                >
                  <strong>
                    {translate("library.addToMyPlan.popup.desc")}{" "}
                    {getUIFormatDate(selectedPlanDetail?.brandDeadlines[0]?.deadline)}.
                  </strong>
                  <div>{translate("library.addToMyPlan.popup.subDesc")}</div>
                </Typography>
              )}
              <Calender
                sx={{ marginLeft: isMobileScreen ? "0px" : "80px", width: isMobileScreen ? "100%" : "auto" }}
                showLable={false}
                buttonView={false}
                onChange={(val: any) => setDueDate(val)}
              />
              {dueDate > selectedPlanDetail?.brandDeadlines[0]?.deadline && (
                <Box marginTop={"8px"} display={"flex"} textAlign={"left"}>
                  <Typography
                    variant={"label"}
                    children={translate("library.addToMyPlan.popup.beyondDate")}
                  ></Typography>
                </Box>
              )}
            </Box>
          </div>
        </DialogFormation>
      )}
    </>
  );
}
